import DOMPurify from "dompurify";
import { marked } from "marked";
import PropTypes from "prop-types";
import React, { useMemo } from "react";
import "../../scss/markdown.scss";

// Renders untrusted markdown (e.g. LLM-generated summaries) as sanitized
// HTML. breaks:true keeps single line breaks of legacy plain-text content.
function Markdown({ text }) {
  const html = useMemo(
    () => DOMPurify.sanitize(marked.parse(text || "", { gfm: true, breaks: true, async: false })),
    [text],
  );

  return <div className="markdown-content" dangerouslySetInnerHTML={{ __html: html }} />;
}

Markdown.propTypes = {
  text: PropTypes.string,
};

export default Markdown;
